<template>
    <component :is="wrapper" :class="['rwl-alert', variation]">
        <p class="rwl-alert__content">
        <slot></slot>
        </p>
        <button class="rwl-alert__close"  @click="dismiss">
            <slot name="close" v-bind:close="close">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 1L1 13" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M1 1L13 13" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </slot>
        </button>
    </component>
</template>

<script>
    export default {
        name: "RwlAlert",
        props: {
            /**
             * The html element name used for the wrapper.
             * `div, section`
             * @values div, section
             */
            wrapper: {
                type: String,
                default: "div",
                validator: value => {
                    return value.match(/(div|section)/)
                },
            },
            /**
             * Style variation to give additional meaning.
             * `primary, secondary`
             */
            variation: {
                type: String,
                default: "primary",
                validator: value => {
                    return value.match(/(primary|secondary|success|danger|warning|info)/)
                },
            },
        },
        model: {
            prop: 'show',
            event: 'input'
        },
        methods: {
            close() {

            },
            dismiss() {

                this.$emit('input', false);
            }
        }

    }
</script>

<docs>
    ```jsx
        <rwl-alert variation="primary">I am primary alert and I got a <a href="#">link</a> </rwl-alert>
        <rwl-alert variation="secondary">I am primary secondary and I got a, <a href="#">link</a> </rwl-alert>
        <rwl-alert variation="success">I am primary success and I got a, <a href="#">link</a> </rwl-alert>
        <rwl-alert variation="danger">I am primary danger and I got a, <a href="#">link</a> </rwl-alert>
        <rwl-alert variation="warning">I am primary warning and I got a, <a href="#">link</a> </rwl-alert>
        <rwl-alert variation="info">I am primary info and I got a, <a href="#">link</a> </rwl-alert>
    ```
</docs>
